import React, { useEffect, useState } from 'react'
import logo from "../assets/logo.webp"
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { AiOutlineDashboard, AiOutlineLogout, AiOutlineMenu, AiOutlineSetting, AiFillCloseCircle, AiFillProfile } from "react-icons/ai";
import { getSingleDataFromDatabase } from '../utils/api';
import { ImProfile } from "react-icons/im";
import { BASEURLS } from '../utils/BaseUrl';
import { IoShareSocialSharp } from "react-icons/io5";
import { RiDashboardLine, RiHeartPulseLine, RiShoppingBagLine, RiShoppingCartLine, RiStore2Line, RiWhatsappLine } from 'react-icons/ri';

const Sidebar = () => {
    const [mobileMenu, setMobileMenu] = useState(false);
    const subagentid = localStorage.getItem('subagentdata');
    const [subagent, setSubagent] = useState([]);

    const openMobileMenu = () => {
        if (mobileMenu) {
            setMobileMenu(false)
        }
        else {
            setMobileMenu(true)
        }
    }

    useEffect(() => {
        getSingleMisData(subagentid);
    }, [subagentid]);

    const getSingleMisData = (subagentid) => {
        getSingleDataFromDatabase(`sub-agent-get-single-data/${subagentid}`).then((res) => {
            if (res.data.status === 1) {
                setSubagent(...[res.data.subagentdata]);
            }
        })
    }
    const navigate = useNavigate();
    function logout() {
        localStorage.clear();
        navigate("/");
    }
    return (
        <div className="wrapper">
            <div className="topbarSection">
                <div className="topbar">
                    <div className="mobile-toggle-menu">
                        <Link to="/dashboard">
                            <img src={logo} alt="Logo" />
                        </Link>
                    </div>
                    <nav className="navbar navbar-expand">
                        <div className="user-box dropdown desktopDisplay">
                            <button className="d-flex align-items-center nav-link" role="button">
                                <div className="username">
                                    <div className="userimg">
                                        {(() => {
                                            if (subagent) {
                                                return (
                                                    <img className="rounded-circle" src={BASEURLS(subagent?.subagent_foto)} alt={subagent?.subagent_foto} />
                                                )
                                            }
                                            else {
                                                return (
                                                    <img className="rounded-circle" src={BASEURLS("user.png")} alt="user.png" />
                                                )
                                            }
                                        })()}

                                    </div>
                                    <div className="user-info ps-3">
                                        <p className="user-name mb-0 dropdown-toggle" data-bs-toggle="dropdown">{subagent?.subagent_name}</p>
                                        <p className="designattion mb-0">Sub Agent</p>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <Link className="dropdown-item" to="/my-profile"><AiOutlineSetting />Settings</Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" onClick={logout} to="javascript:void(0)"><AiOutlineLogout />LogOut</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div className="mobileDisplay">
                            <button onClick={openMobileMenu}>
                                {mobileMenu ?
                                    (
                                        <AiFillCloseCircle className="mobileMenuIcones" />
                                    )
                                    :
                                    (
                                        <AiOutlineMenu className="mobileMenuIcones" />
                                    )
                                }
                            </button>
                        </div>
                    </nav>
                </div>
            </div>
            <div className="sidebarWrapper desktopDisplay">
                <div className="simplebar-mask">
                    <div className="simplebar-offset">
                        <div className="simplebar-content-wrapper">
                            <div className="simplebar-content mm-active">
                                <ul className="metismenu mm-show" id="menu">
                                    <li>
                                        <NavLink activeclassname="active" to="/dashboard">
                                            <RiDashboardLine />
                                            <span>Dashboard</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeclassname="active" to="/all-orders">
                                            <RiShoppingBagLine />
                                            <span>All Orders</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeclassname="active" to="/abandoned-orders">
                                            <RiShoppingCartLine />
                                            <span>Abandoned Orders</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/retention">
                                            <RiHeartPulseLine /><span>Retention</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/skinrange-orders">
                                            <RiStore2Line /><span>Skinrange Orders</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/satkartar-orders">
                                            <RiStore2Line /><span>Satkartar Orders</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/rahul-skinrange-orders">
                                            <RiStore2Line /><span>Rahul Skinrange Orders</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/whatsapp-leads">
                                            <RiWhatsappLine /><span>WhatsApp Leads</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeclassname="active" to="/my-profile">
                                            <AiFillProfile />
                                            <span>My Profile</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink onClick={logout} to="javascript:void(0)">
                                            <AiOutlineLogout />
                                            <span>Log Out</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${mobileMenu ? "" : "mobileMenuActive"}`}>
                <div className="mobilesidebarWrapper mobileDisplay">
                    <div className="simplebar-mask">
                        <div className="simplebar-offset">
                            <div className="simplebar-content-wrapper">
                                <div className="simplebar-content mm-active">
                                    <ul className="metismenu mm-show" id="menu">
                                        <li>
                                            <NavLink activeclassname="active" to="/dashboard">
                                                <AiOutlineDashboard />
                                                <span>Dashboard</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeclassname="active" to="/all-orders">
                                                <AiOutlineSetting />
                                                <span>All Orders</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeclassname="active" to="/abandoned-orders">
                                                <AiOutlineSetting />
                                                <span>Abandoned Orders</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/satkartar-orders">
                                                <RiStore2Line />
                                                <span>Satkartar Orders</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink onClick={logout} to="javascript:void(0)">
                                                <AiOutlineLogout />
                                                <span>LogOut</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sidebar
